import React from "react";
import { CasesFeedbackModal } from "../../FeedbackModal/CasesFeedback";
import "./Feedback.scss";

/* The telecaller variant of the Feedback tab: the same form the case rows
   open as a modal, rendered inline. The wrapper used to add its own 20px of
   inline padding on top of the card padding the form already carries. */
const Feedback = ({ data }) => {
    return (
        <div className="caseFeedback feedback-section-wrapper">
            <CasesFeedbackModal
                open={true}
                setOpen={() => {}}
                data={{
                    ...data,
                    id: data?.case_id || data?.id,
                }}
                isModal={false}
            />
        </div>
    );
};

export default Feedback;
